import React, { useState, useEffect } from "react";
import { Tooltip, DatePicker, Select } from "antd";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../../Layouts/Sidebar";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import secureLocalStorage from "react-secure-storage";
import LeaveEntitlementService from "../../../Services/LeaveEntitlementService";
import DataParser from "../../../utlits/Dataparser";
import LeaveApplicationService from "../../../Services/LeaveApplicationService";
import moment from "moment";
import StatusBadgeHr from "../../Reuseable/StatusBadgeHr";
import AddLeavesHr from "./AddLeavesHr-OLD.jsx";
import UserProfile from "../../Reuseable/UserProfile..jsx";
import SocketService from "../../../Services/SocketService";
import "react-loading-skeleton/dist/skeleton.css";
import TableSkeleton from "../../Reuseable/TableSkeleton";

const LeavesHead = () => {
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const navigate = useNavigate();
  const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
  const role = adminInfo?.user?.userdata?.role_title;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [DataForEmployee, setDataForEmployee] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  const [dateRangeFilter, setDateRangeFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [userFilter, setUserFilter] = useState("all");

  // Serach states
  const [Loading, setLoading] = useState(false);
  const [userEntitlementList, setUserEntitlementsList] = useState([]);
  const [userLeaveCheck, setUserLeavesCheck] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [leaveStatus, setLeaveStatus] = useState("");
  const [leaveFrom, setLeaveFrom] = useState("");
  const [leaveTo, setLeaveTo] = useState("");
  const compid = DataParser.CompanyId();
  const userid = DataParser.UserId();


  console.log("User_id:", userid);

  const [reasonText, setReasonText] = useState("");
  const [employeText, setemployeText] = useState("");
  const [employeImage, setemployeImage] = useState("");
  const [fromdateText, setfromdateText] = useState("");
  const [todateText, settodateText] = useState("");
  const [noofdaysText, setnoofdaysText] = useState("");
  const [allowedleavesText, setallowedleavesText] = useState("");
  const [leavebalanceText, setleavebalanceText] = useState("");
  const [statusText, setstatusText] = useState("");
  const [actiontakenbyText, setactiontakenbyText] = useState("");
  const [leavetypeText, setLeaveTypeText] = useState("");
  const depid = DataParser.departmentId();

  const getUserEntitlements = () => {
    LeaveEntitlementService.userLeaveEntitlement(userid, compid).then((res) => {
      const Data = res.data.entitlement;
      setUserEntitlementsList(Data);
    });
  };

  useEffect(() => {
    getLeaveApplicationsAll();
    getUserEntitlements();
    userLeaves();
  }, []);

  // 🟢 Socket Integration
  useEffect(() => {
    SocketService.connect();

    const handleLeaveUpdate = (data) => {
      if (data.company_id === compid) {
        console.log("🔔 Head Leave update received:", data);
        getLeaveApplicationsAll();
        getUserEntitlements();
      }
    };

    SocketService.on("leave_update", handleLeaveUpdate);

    return () => {
      SocketService.off("leave_update", handleLeaveUpdate);
    };
  }, [compid]);

  useEffect(() => {
    if (pageSize > 10) {
      setCurrentPage(1);
    }
  }, [pageSize]);

  const DataForAdmin = [
    {
      Employee: "Employee Admin First",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
    {
      Employee: "Employee Admin Last",
      LeaveType: "Leave Type",
      From: "From",
      To: "To",
      NoOfDates: "No of Days",
      Reason: "Reason",
      Status: "Status",
    },
  ];

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getLeaveApplicationsAll = () => {
    setLoading(true);
    LeaveApplicationService.getLeaveApplicationHead(compid, userid).then(
      (res) => {
        console.log("Res: ", res);
        const data = res.data.leave_applications || [];
        const uniqueData = Array.from(new Map(data.map(item => [item.id, item])).values());
        setDataForEmployee(uniqueData);
      }
    )
      .finally(() => {
        setLoading(false);
      });
  };

  const userLeaves = () => {
    LeaveApplicationService.userLeave(userid, compid).then((res) => {
      const data = res.data.userLeaves;

      var max = data.reduce(function (a, b) {
        return a > b ? a : b;
      });
      setUserLeavesCheck(max.date);
    });
  };

  const getFilteredData = () => {
    let filtered = [...DataForEmployee];

    if (dateRangeFilter && dateRangeFilter.length === 2) {
      const [start, end] = dateRangeFilter;
      filtered = filtered.filter(item => {
        const itemStartDate = moment(item.from_date);
        const itemEndDate = moment(item.to_date);
        return (
          (itemStartDate.isSameOrAfter(start, 'day') && itemStartDate.isSameOrBefore(end, 'day')) ||
          (itemEndDate.isSameOrAfter(start, 'day') && itemEndDate.isSameOrBefore(end, 'day')) ||
          (itemStartDate.isBefore(start, 'day') && itemEndDate.isAfter(end, 'day'))
        );
      });
    }

    if (statusFilter !== "all") {
      filtered = filtered.filter(item => String(item.status) === statusFilter);
    }

    if (userFilter !== "all") {
      filtered = filtered.filter(item => String(item?.user?.id) === userFilter);
    }

    if (searchValue !== "") {
      filtered = filtered.filter((el) =>
        el?.leav_type?.name?.toLowerCase().includes(searchValue.toLowerCase())
      );
    }

    return filtered;
  };

  const filteredData = getFilteredData();
  const DataE = paginate(filteredData, currentPage, pageSize);

  // Extract unique users for the user filter dropdown
  const uniqueUsers = [];
  const userIds = new Set();
  DataForEmployee.forEach(item => {
    if (item?.user?.id && !userIds.has(item.user.id)) {
      userIds.add(item.user.id);
      uniqueUsers.push(item.user);
    }
  });

  const ClearFilter = (e) => {
    e.preventDefault();
    setEmployeeName("");
    setLeaveType("");
    setLeaveStatus("");
    setLeaveFrom("");
    setLeaveTo("");
  };

  const GotoUser = (e, s) => {
    e.preventDefault();
    //alert(s.user.id)
    navigate(`/${DataParser.CompanyIdentifierRole()}/employee_leaves`, {
      state: { data: s.user.id },
    });
  };

  // const handleViewReason = (reason) => {
  //   setReasonText(reason || "No reason provided");
  //   const modal = new window.bootstrap.Modal(
  //     document.getElementById("reasonModal")
  //   );
  //   modal.show();
  // };

  const handleViewReason = (reason, leav_type, username, userimage, from_date, to_date, totalleaves, allowed_leaves, remaining_leaves, status, approved_by, leavedates) => {
    setReasonText(reason || "No reason provided");
    setLeaveTypeText(leav_type || "")
    setemployeText(username || "");
    setemployeImage(userimage || "");

    // Fallback for N/A dates
    let finalFrom = from_date;
    let finalTo = to_date;
    if ((!from_date || from_date === "N/A" || !moment(from_date).isValid()) && leavedates && leavedates[0]) {
      const m = moment(leavedates[0], "DD-MM-YYYY");
      if (m.isValid()) finalFrom = m.format("YYYY-MM-DD");
    }
    if ((!to_date || to_date === "N/A" || !moment(to_date).isValid()) && leavedates && leavedates[0]) {
      const m = moment(leavedates[0], "DD-MM-YYYY");
      if (m.isValid()) finalTo = m.format("YYYY-MM-DD");
    }

    // Ensure they don't hold "Invalid date" string from format call
    if (finalFrom === "Invalid date") finalFrom = "N/A";
    if (finalTo === "Invalid date") finalTo = "N/A";

    setfromdateText(finalFrom || "N/A");
    settodateText(finalTo || "N/A");
    setnoofdaysText(totalleaves || null)

    // Show N/A in modal for Absent Penalty or Absent type
    if (leav_type === "Absent Penalty" || leav_type === "Absent") {
      setallowedleavesText("N/A");
      setleavebalanceText("N/A");
    } else {
      setallowedleavesText(allowed_leaves || null);
      setleavebalanceText(remaining_leaves || null);
    }
    setstatusText(status || "");
    setactiontakenbyText((status == 3 || status == 4) ? "System" : (approved_by || ""));
    const modal = new window.bootstrap.Modal(
      document.getElementById("reasonModal")
    );
    modal.show();
  };

  return (
    <>
      <Helmet>
        <title>Leaves - Planit</title>
      </Helmet>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <style>{`
                    .card, .card-body, .listing-table-wrapper,
                    .listing-table, .listing-table thead, .listing-table tr,
                    .listing-table th, .listing-table td {
                        border-radius: 0 !important;
                        box-shadow: none !important;
                        border-left: none !important;
                        border-right: none !important;
                        border-top: none !important;
                    }
                    .listing-table thead tr.tableHeaderbg th {
                        background-color: #F2F2F2 !important;
                        color: #212529 !important;
                        border-bottom: none !important;
                        font-weight: 600 !important;
                        font-size: 13px !important;
                        padding: 8px 12px !important;
                    }
                    .listing-table tbody tr td { border-bottom: 1px solid #F2F2F2 !important; vertical-align: middle !important; }
                    .listing-table tbody tr:last-child td { border-bottom: none !important; }

                    /* Filter fields */
                    .custom-filter.float-select-wrap .ant-select-selector,
                    .custom-filter.float-select-wrap .ant-picker {
                        height: 34px !important; min-height: 34px !important; border-radius: 6px !important;
                    }
                    .custom-filter.float-select-wrap .ant-select-selection-item,
                    .custom-filter.float-select-wrap .ant-select-selection-placeholder,
                    .custom-filter.float-select-wrap .ant-picker-input > input { line-height: 30px !important; font-size: 13px !important; }
                    .custom-filter.float-select-wrap label { font-size: 11px !important; font-weight: 600 !important; }
                    .ant-picker-range .ant-picker-active-bar { background: #1D1D1D !important; }

                    /* Hover on filter fields */
                    .custom-filter.float-select-wrap:hover .ant-select-selector,
                    .custom-filter.float-select-wrap:focus-within .ant-select-selector {
                        border-color: #1D1D1D !important; box-shadow: none !important;
                    }
                    .custom-filter.float-select-wrap:hover .ant-picker,
                    .custom-filter.float-select-wrap .ant-picker-focused {
                        border-color: #1D1D1D !important; box-shadow: none !important;
                    }
                    .custom-filter.float-select-wrap:hover label,
                    .custom-filter.float-select-wrap:focus-within label { color: #1D1D1D !important; }
                    .custom-filter.float-select-wrap:hover .ant-select-arrow,
                    .custom-filter.float-select-wrap:focus-within .ant-select-arrow { color: #1D1D1D !important; }
                    .custom-filter.float-select-wrap:hover .ant-picker-suffix div,
                    .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div { background-color: #1D1D1D !important; }
                    .custom-filter.float-select-wrap:hover .ant-picker-suffix div i,
                    .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div i { color: #fff !important; }

                    /* Table fixed layout */
                    .listing-table { table-layout: fixed; width: 100%; min-width: 900px; }
                    .listing-table th, .listing-table td { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
                    .listing-table th:nth-child(1), .listing-table td:nth-child(1) { width: 13%; }
                    .listing-table th:nth-child(2), .listing-table td:nth-child(2) { width: 10%; }
                    .listing-table th:nth-child(3), .listing-table td:nth-child(3) { width: 11%; }
                    .listing-table th:nth-child(4), .listing-table td:nth-child(4) { width: 12%; }
                    .listing-table th:nth-child(5), .listing-table td:nth-child(5) { width: 10%; }
                    .listing-table th:nth-child(6), .listing-table td:nth-child(6) { width: 10%; }
                    .listing-table th:nth-child(7), .listing-table td:nth-child(7) { width: 8%; }
                    .listing-table th:nth-child(8), .listing-table td:nth-child(8) { width: 11%; }
                    .listing-table th:nth-child(9), .listing-table td:nth-child(9) { width: 11%; }
                    .listing-table th:nth-child(10), .listing-table td:nth-child(10) { width: 6%; }
                    .listing-table-wrapper { overflow-x: auto; }
                    .table-body-wrapper { position: relative; }
                    .table-loader-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.75); display: flex; align-items: center; justify-content: center; z-index: 10; min-height: 60px; }
                `}</style>

                <div className="d-flex align-items-center justify-content-end" style={{ padding: "0 0 12px 0" }}>

                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <div className={`float-select-wrap custom-filter ${userFilter !== "all" ? "has-value" : ""}`} style={{ width: "220px", maxWidth: "220px" }}>
                      <label>Employee</label>
                      <Select
                        showSearch
                        allowClear
                        placeholder=""
                        value={userFilter === "all" ? null : userFilter}
                        onChange={(val) => setUserFilter(val || "all")}
                        dropdownStyle={{ zIndex: 1050 }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                      >
                        <Option value="all" label="All">All</Option>
                        {uniqueUsers.map(u => (
                          <Option key={u.id} value={String(u.id)} label={u.name}>{u.name}</Option>
                        ))}
                      </Select>
                    </div>

                    <div className={`float-select-wrap custom-filter ${statusFilter !== "all" ? "has-value" : ""}`} style={{ width: "200px", maxWidth: "200px" }}>
                      <label>Status</label>
                      <Select
                        allowClear
                        placeholder=""
                        value={statusFilter === "all" ? null : statusFilter}
                        onChange={(val) => setStatusFilter(val || "all")}
                        dropdownStyle={{ zIndex: 1050 }}
                      >
                        <Option value="all" label="All">All</Option>
                        <Option value="0" label="Pending">Pending</Option>
                        <Option value="1" label="Approved">Approved</Option>
                        <Option value="2" label="Disapproved">Disapproved</Option>
                        <Option value="3" label="Late-In">Late-In</Option>
                        <Option value="4" label="Absent">Absent</Option>
                      </Select>
                    </div>

                    <div className={`float-select-wrap custom-filter ${(dateRangeFilter && dateRangeFilter.length > 0) ? "has-value" : ""}`} style={{ width: "280px", maxWidth: "280px" }}>
                      <label>Leave Period</label>
                      <RangePicker
                        value={dateRangeFilter}
                        onChange={(val) => setDateRangeFilter(val)}
                        allowClear
                        separator=""
                        placeholder={['', '']}
                        suffixIcon={
                          <div style={{
                            backgroundColor: "#F4F4F4",
                            borderRadius: "6px",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "-4px"
                          }}>
                            <i className="uil-schedule" style={{ color: "#A0A0A0", fontSize: "15px" }} />
                          </div>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th className="text-start ps-4">Employee</th>
                            <th className="text-start">Leave Type</th>
                            <th className="text-start">Allowed Leaves</th>
                            <th className="text-start">Remaining Leaves</th>
                            <th className="text-start">Start Date</th>
                            <th className="text-start">End Date</th>
                            <th className="text-start">Total Days</th>
                            <th className="text-start">Status</th>
                            <th className="text-start">Action Taken By</th>
                            <th className="text-start pe-4">View</th>
                          </tr>
                        </thead>
                      </table>
                      <div className="table-body-wrapper">
                        <table className="table mb-0 custom-table listing-table">
                          <colgroup>
                            <col style={{ width: "13%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "12%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "8%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "6%" }} />
                          </colgroup>
                          <tbody>
                            {Loading ? <TableSkeleton cols={10} rows={6} /> : DataForEmployee.length > 0 ? (
                              DataE.length > 0 ? (
                                DataE.map((el, index) => (
                                  <tr key={index} role="row" className={`${index % 2 === 0 ? "odd" : "even"} text-center`}>
                                    <td className="tableset text-start ps-4" onClick={(e) => GotoUser(e, el)} style={{ cursor: 'pointer' }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <UserProfile username={el?.user?.name} userImage={el?.user?.image} style={{ width: '22px', height: '22px' }} />
                                        <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}>{el?.user?.name}</span>
                                      </div>
                                    </td>
                                    <td className="tableset">
                                      {el.leav_type !== null ? (el.leav_type.name === "Absent Penalty" ? "Absent" : el.leav_type.name) : "-"}
                                    </td>
                                    <td className="tableset">
                                      {(el.leave_type_name === "Absent Penalty" || el.leav_type?.name === "Absent Penalty" || el.leav_type?.name === "Absent") ? "N/A" : (el.leav_type?.allowed_leaves ?? "-")}
                                    </td>
                                    <td className="tableset">
                                      {(el.leave_type_name === "Absent Penalty" || el.leav_type?.name === "Absent Penalty" || el.leav_type?.name === "Absent") ? "N/A" : (el.leav_type?.remaining_leaves ?? "-")}
                                    </td>
                                    <td className="tableset">
                                      {el.status == 3 ? "N/A" : ((el.from_date && el.from_date !== "N/A" && moment(el.from_date).isValid())
                                        ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.from_date).format("D, MMMM")}</span>
                                        : (el.leavedates && el.leavedates[0] && moment(el.leavedates[0], "DD-MM-YYYY").isValid()
                                          ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.leavedates[0], "DD-MM").format("D, MMMM")}</span>
                                          : "N/A"))}
                                    </td>
                                    <td className="tableset">
                                      {el.status == 3 ? "N/A" : ((el.to_date && el.to_date !== "N/A" && moment(el.to_date).isValid())
                                        ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.to_date).format("D, MMMM")}</span>
                                        : (el.leavedates && el.leavedates[0] && moment(el.leavedates[0], "DD-MM-YYYY").isValid()
                                          ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.leavedates[0], "DD-MM").format("D, MMMM")}</span>
                                          : "N/A"))}
                                    </td>
                                    <td className="tableset">{el.totalleaves}</td>
                                    <td className="tableset">
                                      <StatusBadgeHr item={el} api={LeaveApplicationService.leaveStatusUpdate} />
                                    </td>
                                    <td className="tableset text-center">
                                      {el.status == 3 || el.status == 4 ? "System" : (el?.approved_By?.name || "-")}
                                    </td>
                                    <td className="tableset">
                                      <Link to="#" className="cursor-pointer iconscolor"
                                        onClick={() => handleViewReason(el.reason, (el.leav_type.name === "Absent Penalty" ? "Absent" : el.leav_type.name), el?.user?.name, el?.user?.image, el.from_date, el.to_date, el.totalleaves, el.leav_type.allowed_leaves, el.leav_type.remaining_leaves, el.status, (el.status == 3 || el.status == 4) ? "System" : el?.approved_By?.name, el.leavedates)}>
                                        <Tooltip title="View your leave details.">
                                          <i className="uil-eye iconscolor" />
                                        </Tooltip>
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="10" className="text-center">
                                    {statusFilter === "0" ? "No Pending leave records found."
                                      : statusFilter === "1" ? "No Approved leave records found."
                                      : statusFilter === "2" ? "No Disapproved leave records found."
                                      : statusFilter === "3" ? "No Late-In records found."
                                      : statusFilter === "4" ? "No Absent records found."
                                      : "No matching leave records found."}
                                  </td>
                                </tr>
                              )
                            ) : !Loading ? (
                              <tr><td colSpan="10" className="text-center">No leave records found.</td></tr>
                            ) : (
                              <tr><td colSpan="10" style={{ height: "60px" }}></td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>


                  {filteredData.length > pageSize && (
                    <div className="d-flex justify-content-center mt-4">
                      <Pagination
                        itemCount={filteredData.length}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        onPageChange={handelPageChange}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>




        <div
          className="modal fade"
          id="reasonModal"
          tabIndex="-1"
          aria-labelledby="reasonModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-0" style={{ borderRadius: "12px", overflow: "hidden", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}>
              {/* Heading */}
              <div className="modal-header border-0 px-4 py-3 bg-white pb-0">
                <h5 className="modal-title fw-bold" id="reasonModalLabel" style={{ color: "#1D1D1D", fontSize: "1.1rem" }}>
                  Leave Details
                </h5>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body p-4 bg-white">
                {/* Loading */}
                {Loading ? (
                  <div className="text-center py-5">
                    <div
                      className="spinner-border"
                      role="status"
                      style={{ color: "#0DDFAB", width: "2.5rem", height: "2.5rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : leavetypeText ? (
                  <div className="leave-details">
                    {[
                      [
                        "Employee",
                        <div className="d-flex align-items-center gap-2">
                          <UserProfile username={employeText} userImage={employeImage} />{" "}
                          <span>{employeText}</span>
                        </div>,
                      ],
                      ["Leave Type", <span className="fw-medium">{leavetypeText}</span>],
                      ["Allowed Leaves", allowedleavesText],
                      ["Remaining Leaves", leavebalanceText],
                      ["From", statusText == 3 ? "N/A" : ((fromdateText && fromdateText !== "N/A" && moment(fromdateText).isValid()) ? moment(fromdateText).format("DD/MM/YYYY") : "N/A")],
                      ["To", statusText == 3 ? "N/A" : ((todateText && todateText !== "N/A" && moment(todateText).isValid()) ? moment(todateText).format("DD/MM/YYYY") : "N/A")],
                      ["Total Days", <span className="fw-bold text-dark">{noofdaysText}</span>],
                      [
                        "Status",
                        (statusText == 0 || statusText === null || statusText === undefined || statusText === "") ? (
                          <span className="badge px-3" style={{ backgroundColor: "#fdfd96", color: "#856404", border: "1px solid #ced4da", borderRadius: "5px" }}>Pending</span>
                        ) : statusText == 1 ? (
                          <span className="badge px-3" style={{ backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb", borderRadius: "5px" }}>Approved</span>
                        ) : statusText == 3 ? (
                          <span className="badge px-3" style={{ backgroundColor: "#f2fffb", color: "#0bc698", border: "1px solid #b2ebf2", borderRadius: "5px" }}>Late-In</span>
                        ) : statusText == 4 ? (
                          <span className="badge px-3" style={{ backgroundColor: "#ffebee", color: "#c62828", border: "1px solid #ef9a9a", borderRadius: "5px" }}>Absent</span>
                        ) : (
                          <span className="badge px-3" style={{ backgroundColor: "#f8d7da", color: "#721c24", border: "1px solid #f5c6cb", borderRadius: "5px" }}>Disapproved</span>
                        )
                      ],
                      ["Action Taken By", <span className="text-muted">{actiontakenbyText}</span>],
                      ["Reason", <div style={{ fontSize: "0.9rem", color: "#666" }}>{reasonText}</div>],
                    ].map(([label, value], idx) => (
                      <div key={idx} className={`mb-3 d-flex flex-wrap align-items-start ${idx === 9 ? "" : "border-bottom"} pb-2`}>
                        <div style={{ minWidth: "140px", fontWeight: "600", color: "#495057", fontSize: "0.9rem" }}>
                          {label}:
                        </div>
                        <div className="flex-grow-1" style={{ color: "#212529", lineHeight: "1.5", wordBreak: "break-word", fontSize: "0.9rem" }}>
                          {value}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-5 text-muted">No leave record found.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>
  );
};

export default LeavesHead;
